import React, { useEffect } from 'react';

import AsyncCreatableSelect from 'react-select/async-creatable';
import { components } from 'react-select';
import {styles, theme} from "../../../../Components/Inputs/SelectInput";
import PropTypes from "prop-types";
import { VISITORS_API_URL } from "../../Visitors";

const filterColors = (options, inputValue) => {
    return options.filter(i =>
        i.label
    );
};

const VisitorNameInput = (props) => {
    const [ inputValue, setInputValue ] = React.useState('');
    const [ cacheOptions, setCacheOptions ] = React.useState(true);
    const [ menuIsOpen, setMenuIsOpen ] = React.useState(false);
    const [ limitRequests, setLimitRequests ] = React.useState(false);
    const [ limitRequestTimeout, setLimitRequestTimeout ] = React.useState(null);

    /**
     *  Slightly funky mechanism for limiting repeat requests on typeahead
     */

    const promiseOptions = (searchTerm) => {
        return new Promise((resolve, reject) => {
            clearTimeout(limitRequestTimeout);
            if (!limitRequests) {
                makeRequest(searchTerm, resolve);
            } else {
                setLimitRequestTimeout(setTimeout(() => {
                    makeRequest(searchTerm, resolve);
                }, 1100));
            }
        });
    }

    const makeRequest = (searchTerm, resolve) => {
        clearTimeout(limitRequestTimeout);
        setLimitRequests(true);
        axios.get(`${VISITORS_API_URL}components/select/previous-visitors`, {
            params: {
                search: searchTerm
            }
        }).then(res => {
            setLimitRequests(false);
            resolve(res.data.results);
        });
    }
    
    /**
     * Set the react select inputValue whenever changes are made to the
     * selected value, ie when form state is cleared, an option is selected from list
     */
    useEffect(() => {
        setInputValue(props.value);
    }, [props.value])

    // TODO: Separate out into another component?
    const Option = (props) => {
        const {
            className,
            cx,
            getStyles,
            isDisabled,
            isFocused,
            isSelected,
            innerRef,
            innerProps,
        } = props;

        return (
            <>
                {props.data.__isNew__ &&  <components.Option {...props} />}
                {!props.data.__isNew__ &&
                    <div
                        css={getStyles('option', props)}
                        className={cx(
                            {
                                option: true,
                                'option--is-disabled': isDisabled,
                                'option--is-focused': isFocused,
                                'option--is-selected': isSelected,
                            },
                            className
                        )}
                        ref={innerRef}
                        {...innerProps}
                    >
                        <div className="visitor-booking-visitor-option-container">
                            <div className="visitor-booking-visitor-option-name">{props.data.label}</div>
                            <small className="visitor-booking-visitor-option-email">{props.data.email}</small>
                        </div>
                        <div className="visitor-booking-visitor-remove">
                            <a href="#" onClick={e => handleRemoveClick(e, props)}>
                                Remove
                            </a>
                        </div>
                    </div>
                }
            </>
        )
    }

    const handleRemoveClick = (e, row) => {
        e.preventDefault();
        e.stopPropagation();

        if (!row.hasOwnProperty('__isNew__')) {
            axios.post(`${VISITORS_API_URL}visitors/remove`, {
                visitorId: row.data.value
            })
            .then(response => {
                setCacheOptions(false);

                setInputValue('');
                setMenuIsOpen(false);
                setCacheOptions(true);
            });
        }
    }

    const handleChange = (option) => {
        let value = '';

        if (option) {
             value = option.label;
             if (option.__isNew__) {
                 value = option.value;
             }
        }

        props.onChange('name', value, props.index);
        setInputValue(value);

        // React-select includes the __isNew__ property when a new option is created
        if (option && !option.hasOwnProperty('__isNew__')) {
            const visitorId = option.value;

            // Get & populate full information about the visitor
            axios.get(`${VISITORS_API_URL}visitors/${visitorId}`).then(response => {
                const previousVisitor = response.data.data.visitor;

                // We must make the change using this method to avoid creating
                // an empty visitor row for each value
                if (props.onChangeMultipleValues) {
                    props.onChangeMultipleValues({
                        email: previousVisitor.email,
                        company: previousVisitor.company,
                    });
                } else {
                    props.onChange('email', previousVisitor.email, props.index);
                    props.onChange('company', previousVisitor.company, props.index);
                }
            });
        }
    }

    const handleInputChange = (textInput, { action }) => {
        if (action === 'input-change') {
            // After typing into the field
            setInputValue(textInput ?? '');

            // If the user has cleared thhe whole text input, we'll need to clear the
            // selected option as well, otherwise a previously selected option will reappear
            if (textInput === '') {
                handleChange(null);
            }

        } else if (action === 'input-blur' && inputValue) {
            // After clicking enter or clicking away from the field, set the option
            handleChange({
                label: inputValue,
                value: inputValue,
                __isNew__: true
            })
        } else if (action === 'set-value') {
        }
    }

    const handleMenuOpen = () => setMenuIsOpen(true);
    const handleMenuClose = () => setMenuIsOpen(false);

    return (
        <AsyncCreatableSelect
            className={`react-select-container ${props.className}`}
            cacheOptions={cacheOptions}
            menuIsOpen={menuIsOpen}
            onMenuOpen={handleMenuOpen}
            onMenuClose={handleMenuClose}
            defaultOptions={false}
            allowCreate={true}
            allowCreateWhileLoading={true}
            isClearable={true}
            createOptionPosition="first"
            loadOptions={promiseOptions}
            onChange={handleChange}
            onInputChange={handleInputChange}
            value={{value: props.value, label: props.value}}
            inputValue={inputValue}
            getOptionLabel={option => (option.hasOwnProperty('email') && option.email.length > 0) ? `${option.label} (${option.email})` : option.label}
            noOptionsMessage={() => "Type to select from previous visitors, or create a new name"}
            theme={theme}
            styles={styles}
            components={{
                Option,
                DropdownIndicator:() => null,
                IndicatorSeparator:() => null,
            }} // Hide dropdown arrow
        />
    );
}

VisitorNameInput.propTypes = {
    index: PropTypes.any,
    value: PropTypes.any,
    onChange: PropTypes.func,
    onChangeMultipleValues: PropTypes.func,
    className: PropTypes.string
}

export default VisitorNameInput;
